export const colors = {
    primary: "#ee6e46",
 };